// src/components/admin/OrderList.js
import React from 'react';
import { Button, Table } from 'react-bootstrap';
import { Edit, Trash } from 'react-feather';

const OrderList = ({ orders, onEdit }) => {
  return (
    <Table striped bordered hover responsive className="align-middle text-center">
  <thead className="table-dark">
    <tr>
      <th>S.No</th>
      <th>Customer ID</th>
      <th>Total Qty</th>
      <th>Total Amount</th>
      <th>Ordered Date</th>
      <th>Delivery Date</th>
      <th>Status</th>
      <th>Actions</th>
    </tr>
  </thead>
  <tbody>
    {orders.length === 0 ? (
      <tr>
        <td colSpan="8" className="text-center">
          No orders found
        </td>
      </tr>
    ) : (
      orders.map((order, index) => (
        <tr key={order.id || index}>
          <td>{index + 1}</td>
          <td>{order.customerId}</td>
          <td>{order.totalQuantity}</td>
          <td>₹{order.totalAmount?.toLocaleString()}</td>
          <td>{order.orderedDate}</td>
          <td>{order.deliveryDate}</td>
          <td>{order.currentStatus}</td>
          <td>
            <Button
              variant="warning"
              size="sm"
              className="me-2"
              onClick={() => onEdit(order)}
            >
              <Edit size={16} />
            </Button>
            {/* If delete is needed, uncomment below */}
            {/* 
            <Button
              variant="danger"
              size="sm"
              onClick={() => onDelete(order.id)}
            >
              <Trash size={16} />
            </Button>
            */}
          </td>
        </tr>
      ))
    )}
  </tbody>
</Table>

  );
};

export default OrderList;